import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  makeStyles,
  Container,
  CardHeader,
  Divider
} from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import MaterialTable from "material-table";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

const screenCode = 'BUDGETCODE';

export default function BudgetCodeListing() {
  const classes = useStyles();
  const [budgetCodeData, setBudgetCodeData] = useState([]);
  const navigate = useNavigate();
  let encrypted = "";
  const handleClickAdd = () => {
    encrypted = btoa('0');
    navigate('/app/BudgetCode/addedit/' + encrypted);
  }
  const handleClickEdit = (budgetCodeID) => {
    encrypted = btoa(budgetCodeID.toString());
    navigate('/app/BudgetCode/addedit/' + encrypted);
  }

  useEffect(() => {
    trackPromise(
      GetAllBudgetCodes(),
      getPermissions()
    );
  }, []);

  async function GetAllBudgetCodes() {
    const result = await services.GetAllBudgetCodes();
    setBudgetCodeData(result);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBUDGETCODE');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClickAdd}
            isEdit={true}
            toolTiptitle={"Add Account Code"}
          />
        </Grid>
      </Grid>
    )
  }

  return (
    <Page
      className={classes.root}
      title="Account Code"
    >
      <Container maxWidth={false}>
        <Box mt={0}>
          <Card>
            <CardHeader
              title={cardTitle("Account Code")}
            />
            <PerfectScrollbar>
              <Divider />
              <Box minWidth={1000}>
                <MaterialTable
                  title="Multiple Actions Preview"
                  columns={[
                    { title: 'Account Code', field: 'budgetCode' },
                    { title: 'Account Code Name', field: 'budgetCodeName' },
                    {
                      title: 'Description', field: 'budgetCodeDescription',
                      render: rowData => rowData.budgetCodeDescription == "" || rowData.budgetCodeDescription == null ? '-' : rowData.budgetCodeDescription,
                    },
                    {
                      title: 'Status', field: 'isActive', lookup: {
                        true: 'Active',
                        false: 'Inactive'
                      }
                    },
                  ]}
                  data={budgetCodeData}
                  options={{
                    exportButton: false,
                    showTitle: false,
                    headerStyle: { textAlign: "left", height: '1%', paddingLeft: '1rem', paddingRight: '1rem' },
                    cellStyle: { textAlign: "left" },
                    columnResizable: false,
                    actionsColumnIndex: -1,
                  }}
                  actions={[
                    {
                      icon: 'edit',
                      tooltip: 'Edit Account Code',
                      onClick: (_, budgetCodeData) => handleClickEdit(budgetCodeData.budgetCodeID)
                    }
                  ]}
                />
              </Box>
            </PerfectScrollbar>
          </Card>
        </Box>
      </Container>
    </Page>
  );
};




